import { combineReducers } from 'redux';

import type { Action } from 'modules/global/generic.types';
import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import type { MayBe } from 'modules/global/typing/common/common';
import * as types from 'modules/messagingAccounts/actionTypes';
import { DASHBOARD_SOURCE } from 'modules/messagingAccounts/constants';

import available from './available';
import filters from './filters';
import modal from './modal';

const dashboardSourceMatcher = ({ meta }: Action) => meta?.source === DASHBOARD_SOURCE;

const selectDeletingId = (payload: MayBe<{ accountId?: string }>): MayBe<string> => payload?.accountId;

export default combineReducers({
  dashboard: combineReducers({
    filters,
    data: createSearchReducers(types.FETCH_MESSAGING_ACCOUNTS, {
      global: { matcher: dashboardSourceMatcher, paginationSlice: true },
    }),
    deleting: loadingArraySlice(types.DELETE_MESSAGING_ACCOUNT, { global: { selectId: selectDeletingId } }),
  }),
  modal,
  available,
});
